'use client';

import { FC } from 'react';
import { appLinkToReadableMap } from '../../../../../maps/maps';
import { cn } from '@shared/shared-utils';
import { type ValueOf } from '../../../../../types/types';
import { AppRoute } from '../../../../../../libs/enums/enums';
import ArrowUpRight from '../../../../../../../public/svg/arrow-up-right.svg';
import Link from 'next/link';

type Properties = {
  pathname: ValueOf<typeof AppRoute>;
};

const AsideNavigatorNavList: FC<Properties> = ({ pathname }: Properties) => {
  return (
    <nav className="mt-8" aria-label="Primary">
      <ul
        className={cn(
          'leading-normal font-semibold text-[22px] flex gap-y-2 flex-col font-roboto-condensed',
          {
            'text-ogn-white': AppRoute.MAIN === pathname,
          },
        )}
      >
        {Object.entries<string>(appLinkToReadableMap)
        .map(([appLink, readable]) => {
          const isExternal = appLink.startsWith('https');
          return (
            <li
              className={cn('pl-12 py-2', {
                'bg-ogn-bright-yellow rounded-r-3xl mr-5':
                  pathname === appLink ||
                  (pathname === AppRoute.HEALING_NAVIGATOR_INFORMATION &&
                    appLink === AppRoute.HEALING_NAVIGATOR),
              })}
              key={appLink}
            >
              <Link
                className={cn('!flex items-center gap-x-2 w-fit', {
                  'fancy-underline': pathname !== appLink,
                })}
                href={appLink}
                target={isExternal ? '_blank' : '_self'}
                rel={isExternal ? 'noopener noreferrer' : undefined}
                aria-label={
                  isExternal ? `${readable} (opens in a new tab)` : readable
                }
              >
                {readable}
                {isExternal && (
                  <>
                    <ArrowUpRight
                      className="w-[20px] h-[20px] mt-1"
                      aria-hidden="true"
                      focusable="false"
                    />
                    <span className="sr-only"> (opens in a new tab)</span>
                  </>
                )}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export { AsideNavigatorNavList };
